import { render, staticRenderFns } from "./ExtraDetails.vue?vue&type=template&id=0067b298&scoped=true&"
import script from "./ExtraDetails.vue?vue&type=script&lang=ts&"
export * from "./ExtraDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraDetails.vue?vue&type=style&index=0&id=0067b298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067b298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
